import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { resetAll } from 'reducers';
import { getRefusedAppointments, RequestAppointments } from 'services';

export type State = ApiState<RequestAppointments, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchRefusedAppointments = createAsyncThunk(
  'get/refusedAppointments',
  async (rowsPerPage: number) => await getRefusedAppointments(rowsPerPage)
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const refusedAppointmentsSlice = createSlice({
  name: 'refusedAppointments',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {
    unmountRefusedAppointments: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRefusedAppointments.pending, (state) => {
      state.isLoading = true;
      state.hasLoaded = false;
    });

    builder.addCase(fetchRefusedAppointments.fulfilled, (state, action: PayloadAction<RequestAppointments>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchRefusedAppointments.rejected, (state, action) => {
      state.isLoading = false;
      state.hasLoaded = true;
      state.error = action.error;
    });

    builder.addCase(resetAll, () => initialState);
  },
});

export const stateSelector_ = (state: { refusedAppointments: State }): State => state.refusedAppointments;

export const refusedAppointments_ = createSelector(stateSelector_, (state) => state.data);

export const refusedAppointmentsIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const refusedAppointmentsHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export const { unmountRefusedAppointments } = refusedAppointmentsSlice.actions;

export default refusedAppointmentsSlice.reducer;
